// Author Lin
// Date 2021-10-03 15:25:13

class MintalMesMstFurnace {
constructor({
        id = null,
        code = '',
        furnaceName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.furnaceName = furnaceName;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesMstFurnace();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.mst.mintalMesMstFurnace.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstFurnace.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.mst.mintalMesMstFurnace.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstFurnace.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    furnaceNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.mst.mintalMesMstFurnace.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'furnaceNameFilter',
        label: 'label.mintal.mst.mintalMesMstFurnace.filter.furnaceName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstFurnace.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.mst.mintalMesMstFurnace.entity.furnaceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstFurnace.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesMstFurnace, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
